import * as React from 'react'
import styled, { css } from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'
import { t } from '@owl-nest/localize'

import { EDIT_MODE_LAPTOP_BREAKPOINT } from '../constants'

type EditButtonProps = {
  children?: React.ReactNode
  className?: string
  fullWidth?: boolean
  glyph?: React.ReactNode
  link: string
}

function EditButtonComponent({
  children,
  className,
  glyph,
  link,
}: EditButtonProps): React.ReactElement<EditButtonProps> {
  return (
    <Anchor href={link} className={className}>
      <plume.EditButton glyph={glyph ? glyph : <plume.glyphs.stroke.Edit size={21} />}>
        {children ? children : t('Edit')}
      </plume.EditButton>
    </Anchor>
  )
}
export const EditButton = styled(EditButtonComponent)<EditButtonProps>`
  ${({ fullWidth }) => {
    if (fullWidth) {
      return css`
        width: calc(100% - 20px);
        margin-top: 0px;
        margin-bottom: 10px;

        ${plume.EditButton} {
          width: 100%;
          justify-content: flex-start;
        }

        @media screen and ${EDIT_MODE_LAPTOP_BREAKPOINT} {
          ${plume.EditButton} {
            align-items: center;
          }
        }
      `
    }
  }}
`

const Anchor = styled.a`
  text-decoration: none;
`
